// Mock data for Magic Prompts platform

export const currentUser = {
  id: '1',
  name: 'Fahim',
  email: 'fahim@example.com',
  avatar: 'F',
  credits: 0.00,
  estimatedValue: 0.00,
};

export const featuredVideo = {
  id: '1',
  title: 'CONNECT AI Magic এ লাইফটাইম এক্সেস এ কি কি পাবেন?',
  type: 'Featured Training Video',
  youtubeId: 'dQw4w9WgXcQ',
};

export const categories = [
  { id: 'all', name: 'All Categories', count: null },
  { id: 'llm', name: 'LLM Prompts', count: 5 },
  { id: 'facebook', name: 'Universal Facebook Post Prompt', count: 7 },
  { id: 'branding', name: 'Personal Branding', count: 1 },
  { id: 'image', name: 'AI Image Prompts', count: 21 },
  { id: 'video', name: 'AI Video Prompts', count: 13 },
  { id: 'thumbnails', name: 'Video and Post Thumbnails', count: 2 },
  { id: 'viral', name: 'Viral Trend', count: 1 },
  { id: 'automation', name: 'Automation Templates', count: 2 },
  { id: 'custom', name: 'Custom GPTs', count: 12 },
];

export const prompts = [
  {
    id: '1',
    title: 'Comic Story + Image Generator',
    description: '',
    image: 'https://images.unsplash.com/photo-1618519764620-7403abdbdfe9?w=100&h=100&fit=crop',
    tags: ['Premium', 'Productivity & Time-Saving', 'Social Media', 'Marketing & Advertising'],
    extraTags: 2,
    isPremium: true,
    category: 'image',
  },
  {
    id: '2',
    title: 'Conversion Objection Analyzer',
    description: 'Commet Browser এ আপনার landing page / sales page / website খুলুন → এই prompt রান করুন →AI সেটি বিশ্লেষণ করে বলবে ক...',
    image: null,
    icon: 'pencil',
    iconBg: 'bg-purple-600',
    tags: ['Premium', 'Recently Added', 'Marketing & Advertising', 'Analytics & Optimization'],
    isPremium: true,
    category: 'llm',
  },
  {
    id: '3',
    title: 'INFOGRAPHIC: All-Purpose Facebook Post Design',
    description: 'এই প্রম্পটটি একজন সিনিয়র গ্রাফিক ডিজাইনারের মতো কাজ করে। এটি আপনার দেওয়া কন্টেন্ট এবং ব্র্যান্ড কালার ব্যবহার করে ফেসবুকের জন্য মডার্ন,...',
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=100&h=100&fit=crop',
    tags: ['Premium', 'Social Media', 'Marketing & Advertising', 'Universal'],
    extraTags: 3,
    isPremium: true,
    category: 'facebook',
  },
  {
    id: '4',
    title: 'Facebook Profile & Page Cover Photo',
    description: 'Personal Profile Cover Photo – ব্যবহার নির্দেশনানিজের প্রোফাইল ছবি আপলোড করুন (জান পাশ দে...',
    image: 'https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=100&h=100&fit=crop',
    tags: ['Premium'],
    isPremium: true,
    category: 'facebook',
  },
  {
    id: '5',
    title: 'AI Video Script Generator',
    description: 'Generate engaging video scripts for YouTube, TikTok, and Instagram Reels.',
    image: 'https://images.unsplash.com/photo-1536240478700-b869070f9279?w=100&h=100&fit=crop',
    tags: ['Premium', 'Social Media', 'Video'],
    isPremium: true,
    category: 'video',
  },
  {
    id: '6',
    title: 'Brand Voice Creator',
    description: 'Create a consistent brand voice guide for all your content.',
    image: null,
    icon: 'mic',
    iconBg: 'bg-blue-600',
    tags: ['Premium', 'Branding'],
    isPremium: true,
    category: 'branding',
  },
];

export const pricingPackages = [
  {
    id: 'starter',
    name: 'Starter',
    priceUSD: 4.00,
    priceBDT: 480.00,
    credits: 500,
  },
  {
    id: 'popular',
    name: 'Popular',
    priceUSD: 9.00,
    priceBDT: 1080.00,
    credits: 1200,
  },
  {
    id: 'pro',
    name: 'Pro',
    priceUSD: 19.00,
    priceBDT: 2280.00,
    credits: 2500,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    priceUSD: 37.00,
    priceBDT: 4500.00,
    credits: 5000,
  },
];

export const aiModels = [
  {
    id: '1',
    name: 'ChatGPT-4',
    category: 'Text Generation',
    rating: 5,
    description: 'Best for complex reasoning and creative writing',
  },
  {
    id: '2',
    name: 'Claude 3.5',
    category: 'Text Generation',
    rating: 5,
    description: 'Excellent for long-form content and analysis',
  },
  {
    id: '3',
    name: 'Midjourney',
    category: 'Image Generation',
    rating: 5,
    description: 'Best for artistic and creative images',
  },
  {
    id: '4',
    name: 'DALL-E 3',
    category: 'Image Generation',
    rating: 4,
    description: 'Great for realistic and detailed images',
  },
];

export const trainingVideos = [
  {
    id: '1',
    title: 'Getting Started with Magic Prompts',
    duration: '12:34',
    thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=300&h=200&fit=crop',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: '2',
    title: 'Advanced Prompt Engineering',
    duration: '18:45',
    thumbnail: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=300&h=200&fit=crop',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: '3',
    title: 'Creating Viral Social Media Content',
    duration: '15:20',
    thumbnail: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=300&h=200&fit=crop',
    youtubeId: 'dQw4w9WgXcQ',
  },
];

export const sidebarItems = [
  { id: 'dashboard', name: 'Dashboard', icon: 'Home', path: '/' },
  { id: 'prompts', name: 'Prompts', icon: 'FileText', path: '/prompts' },
  { id: 'playground', name: 'Play Ground', icon: 'Gamepad2', path: '/playground' },
  { id: 'images', name: 'My Images', icon: 'Image', path: '/images' },
  { id: 'videos', name: 'Training Videos', icon: 'MonitorPlay', path: '/videos' },
  { id: 'watermark', name: 'Watermark Remover', icon: 'Pencil', path: '/watermark' },
  { id: 'notepad', name: 'NotePad', icon: 'StickyNote', path: '/notepad' },
  { id: 'converter', name: 'PDF & Image Converter', icon: 'FileImage', path: '/converter' },
  { id: 'credits', name: 'Credits', icon: 'Coins', path: '/credits' },
  { id: 'profile', name: 'Profile', icon: 'User', path: '/profile' },
];
